import type { User } from '@supabase/supabase-js';

import { addLocalePrefix, resolveLocaleOrDefault } from '@kit/i18n';
import { Header } from '@kit/ui/marketing';

import { AppLogo } from '~/components/app-logo';

import { SiteHeaderAccountSection } from './site-header-account-section';
import { SiteNavigation } from './site-navigation';

export function SiteHeader(props: { user?: User | null; language?: string }) {
  const language = resolveLocaleOrDefault(props.language);
  const homePath = addLocalePrefix('/', language);

  return (
    <Header
      logo={<AppLogo href={`${homePath}#product`} className="h-[30px] w-auto" />}
      navigation={<SiteNavigation language={language} />}
      actions={<SiteHeaderAccountSection user={props.user ?? null} />}
    />
  );
}
